import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34cf3a1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rule-manage-box" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "main-box"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "待跟进的有效线索", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "未来线索", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "无效线索", -1))
const _hoisted_7 = {
  key: 1,
  class: "main-box"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "谈判", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "搁置", -1))
const _hoisted_10 = {
  key: 2,
  class: "main-box"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "对接中", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "暂停合作", -1))
const _hoisted_13 = {
  key: 3,
  class: "main-box"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "一档", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "二档", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "三档", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, "四档", -1))
const _hoisted_18 = {
  key: 4,
  class: "msg-box"
}
const _hoisted_19 = {
  key: 0,
  class: "footer-box"
}
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_DayOffCalendar = _resolveComponent("DayOffCalendar")!
  const _component_CosFixFooterPage = _resolveComponent("CosFixFooterPage")!

  return (_openBlock(), _createBlock(_component_CosFixFooterPage, {
    autoFooter: _ctx.selectData.target !== 'dayOffSetting'
  }, {
    footer: _withCtx(() => [
      (_ctx.selectData.target !== 'dayOffSetting')
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _ctx.handleSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.selectData.title), 1),
        (_ctx.selectData.target === 'saleCue')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", null, [
                _createTextVNode(" 每个用户，每天最多领取"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_1[0],
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("条销售线索。 ")
              ]),
              _hoisted_4,
              _createElementVNode("p", null, [
                _createTextVNode(" 自领取之日起，第一次跟进必须在"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[0],
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内，之后每"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[1],
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日跟进"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[2],
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[2]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("次， ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode(" 连续"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[3],
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[3]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("次跟进期要求未达标，则自动退回公海池; 退回前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_2[4],
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_2[4]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("工作日，通过第三方（飞书）、系统弹窗提醒客户负责人跟进。 ")
              ]),
              _hoisted_5,
              _createElementVNode("p", null, [
                _createTextVNode(" 联系时间到期前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_3[0],
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_3[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日的跟进记录小于"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_3[1],
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_3[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("条，通过第三方（飞书）、系统弹窗提醒客户负责人跟进。 ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode(" 置为【未来线索】后，"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_3[2],
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_3[2]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("天后未变为有效线索，则自动进入公海池。 ")
              ]),
              _hoisted_6,
              _createElementVNode("p", null, [
                _createTextVNode(" 置为【无效线索】后，"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.CLUE_RULE_4[0],
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.saleFormState.CLUE_RULE_4[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("天后未变为有效线索，则自动进入公海池。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'potentialCustomer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_1[0],
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_1[1],
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_1[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_9,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_2[0],
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.POTENTIAL_RULE_2[1],
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.saleFormState.POTENTIAL_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'signCustomer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGNING_RULE_1[0],
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.saleFormState.SIGNING_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGNING_RULE_1[1],
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.saleFormState.SIGNING_RULE_1[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_12,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGNING_RULE_2[0],
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.saleFormState.SIGNING_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGNING_RULE_2[1],
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.saleFormState.SIGNING_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'successCustomer')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_1[0],
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_1[1],
                  "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_1[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_15,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_2[0],
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_2[1],
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_16,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_3[0],
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_3[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_3[1],
                  "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_3[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ]),
              _hoisted_17,
              _createElementVNode("p", null, [
                _createTextVNode(" 距离最后一次跟进记录"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_4[0],
                  "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_4[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日内需要再次跟进，提前"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.DEAL_RULE_4[1],
                  "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.saleFormState.DEAL_RULE_4[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("个工作日开始提醒，通过第三方（飞书）、系统弹窗提醒客户负责人跟进，超时仍未跟进标记【超时】。 ")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectData.target === 'appSignSetting')
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("p", null, [
                _createTextVNode(" 签到列表，展示自身定位"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGN_IN_RULE_1[0],
                  "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.saleFormState.SIGN_IN_RULE_1[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("米范围内的客户信息。（仅能在范围内签到） ")
              ]),
              _createElementVNode("p", null, [
                _createTextVNode(" 签到打卡后，在上次签到范围内"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGN_IN_RULE_2[0],
                  "onUpdate:value": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.saleFormState.SIGN_IN_RULE_2[0]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("分钟后才能第二次打卡签到；同一个客户"),
                _createVNode(_component_a_input_number, {
                  class: "input",
                  precision: 0,
                  min: 1,
                  value: _ctx.saleFormState.SIGN_IN_RULE_2[1],
                  "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.saleFormState.SIGN_IN_RULE_2[1]) = $event)),
                  placeholder: "请输入"
                }, null, 8, ["value"]),
                _createTextVNode("分钟后才能第二次打卡签到。 ")
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.selectData.target === 'dayOffSetting')
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_DayOffCalendar, { typePage: 'cos_ofbu' })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["autoFooter"]))
}